






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import { mapActions, mapMutations } from 'vuex'
import QuickDeposits from '@/components/gambling/QuickDeposit.vue'

@Component({
  components: {
    QuickDeposits
  }
})

export default class Notice extends Vue {
  @Mutation('setAccountType') setAccountType: any

  public $routeChange!: any
  public quickDeposit: boolean = false

  @Prop({
    type: String,
    default: 'You need to deposit'
  }) readonly text!: string
  @Prop(Function) closeEvent!: any

  @Watch('quickDeposit')
  onQuickDeposit (val: boolean) {
    if (!val) {
      this.closeEvent()
    }
  }

  private closeDialog (): void {
    this.quickDeposit = false
  }

  private openQuickDeposit (): void {
    this.setAccountType('banking')
    this.quickDeposit = true
  }
}
